module.exports = __webpack_public_path__ + "img/right_video1.f0b86336.png";